"use client";

import { createFileRoute, Outlet, useLocation } from '@tanstack/react-router'
import { ListIcon, WrenchIcon } from '@phosphor-icons/react'
import AdminToolbar from '@/src/components/layout/AdminToolbar'
import { ToolbarTabLink } from '@/src/components/layout/ToolbarTabToggle'

export const Route = createFileRoute('/_manage/manage/admin/operations')({
  component: AdminOperationsLayout,
})

function AdminOperationsLayout() {
  const location = useLocation()
  const currentPath = location.pathname
  const isTypes = currentPath.includes('/operations/types')

  return (
    <div className="bg-background text-foreground">
      <AdminToolbar>
        <AdminToolbar.Left>
          <div className="flex gap-1">
            <ToolbarTabLink to="/manage/admin/operations/list" active={!isTypes}>
              <ListIcon className="h-4 w-4" />
              Operations
            </ToolbarTabLink>
            <ToolbarTabLink to="/manage/admin/operations/types" active={isTypes}>
              <WrenchIcon className="h-4 w-4" />
              Operation Types
            </ToolbarTabLink>
          </div>
        </AdminToolbar.Left>
      </AdminToolbar>
      <Outlet />
    </div>
  )
}
